<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.rerun_bill') }}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :name="$t('bill.product_type_maintenance')" :action="$t('bill.rerun_bill')" />
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillProductRerunBillDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        this.loading = true
        await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'run',
          },
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
